import React from 'react';
import './css/Contact.css';
import ecls from '../static/etisk_chater_logo_sort.png';

export default () => (
  <div className="contact">
    <div className="contact_right">
      <b>Lina Barbagallo, CEO</b>
      <br />
      <a href="mailto:lina@divamodels.com">
        lina@divamodels.com
      </a>
      <br />
      <br />
      <b>Mariah Van Der Sterren, Booker</b>
      <br />
      <a href="mailto:mariah@divamodels.com">
        mariah@divamodels.com
      </a>
      <br />
      <br />
      <b>Accounts department</b>
      <br />
      <a href="mailto:account@divamodels.com">
        account@divamodels.com
      </a>
      <br />
      <br />
      <b>Other</b>
      <br />
      <a href="mailto:divamodels@divamodels.com">
        divamodels@divamodels.com
      </a>
      <br />
      <br />
      Phone
      <br />
      <a href="tel:+4586197444">
        +45 86 19 74 44
      </a>
    </div>
    <div className="contact_left">
      <b>Office hours</b>
      <br />
      Monday - Friday 9.00 AM - 4.30 PM
      <br />
      <br />
      <b>Bank Handelsbanken</b>
      <br />
      Europaplads 16
      <br />
      DK8100 Aarhus C
      <br />
      Swift code HANDDKKK
      <br />
      IBAN Nr. DK6976330002010198
      <br />
      Bank Account 7633-2010198
      <br />
      <br />
      <b>Diva Models</b>
      <br />
      Nordlandsvej 86
      <br />
      8240 Risskov
      <br />
      Denmark
      <br />
      <a target="_blank" rel="noopener noreferrer" href="https://www.google.dk/maps/place/Nordlandsvej+86,+8240+Risskov">Google Maps</a>
      <br />
      <br />
      CVR/VAT 29611270
      <br />
      <br />
      <img className="contact_left_img" src={ecls} alt="etisk_chater_logo_sort" />
    </div>
  </div>
);
